import infographic from '../assets/infographic.jpg';
import './AboutPage.css';

const AboutPage = () => (
  <div id="about" className="home-page">
      <div className="image-content about-image-container">
        <img 
          src={infographic} 
          alt="HostLink Infographic" 
          className="about-infographic"
        />
      </div>
      <div className="text-content">
         <h2>Digital Signage for the STR</h2>
        <p>
          HostLink is a custom digital signage solution for STR properties in the San Antonio metropolitan area.
        </p>
        <p>
          It runs on any internet-connected device, especially SmartTVs. 
          Powered by React, HostLink updates in real time without installs or complicated setup.
        </p>
      </div>
  </div>
);

export default AboutPage;
